import { Box, BoxProps } from "@chakra-ui/react";

type CardProps = {
  isActive?: boolean;
};

function Card({ children, isActive, onClick, w, px, py }: BoxProps & CardProps) {
  return (
    <Box
      bg={isActive ? "gray.50" : "white"}
      rounded="12px"
      border="solid 1px"
      borderColor={isActive ? "brand.600" : "gray.200"}
      transition={"background-color 0.5s, border-color 0.5s"}
      onClick={onClick}
      w={w}
      px={px}
      py={py}
    >
      {children}
    </Box>
  );
}

export default Card;
